<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->
<div class="wccard p-3 mb-1 text-webbtree-green">
  <a data-testid="auto-app-companylist-a-1" routerLinkActive="active" [routerLink]="['/company-directory/industries']" style="color: inherit;">Industries</a> >
  {{ industry }}
</div>
<div class="wccard p-3 mb-3" *ngIf="companyList.length>0">
  <div class="row">
    <div class="col">
      <h1 class="mb-3">{{industry}}</h1>
      <div class="companydirectory">
        <div class="row mb-6">
          <div class="col-md-3">
            <input data-testid="auto-app-companylist-input-1" type="text" class="wc-form-control"
            placeholder="Company Name"
              [(ngModel)] = "companyName"
              (input)="onKeyPress('company')"
            [matAutocomplete]="company_name" (blur)="removeTypeahead('companyname')">
            <mat-autocomplete #company_name="matAutocomplete">
              <mat-option *ngFor="let company of typeaheads" [value]="company?.companyname"
               (onSelectionChange)="searchRedirect(company?.companyname, company?.companyid)"
               >
                {{company?.companyname}}
              </mat-option>
            </mat-autocomplete>

          </div>
          <div class="col-md-2">
            <input data-testid="auto-app-companylist-input-2" type="text" class="wc-form-control"
            placeholder="City"
              [(ngModel)] = "city"
              (input)="onKeyPress('city')"
            [matAutocomplete]="city_list" (blur)="removeTypeahead('city')">
            <mat-autocomplete #city_list="matAutocomplete">
              <mat-option *ngFor="let city of cityList" [value]="city"
                (onSelectionChange)="applyFilter('city',city)"
                >
                {{city}}
              </mat-option>
            </mat-autocomplete>
          </div>
          <div class="px-3 d-flex align-items-center">

        <span class="clearall-btn text-webbtree-green" (click)="applyFilter('clearall', '')"><i class="fas fa-redo-alt" ></i></span>

          </div>
        </div>

        <div class="row mb-6" *ngFor="let cluster of companyList">
          <div class="col-lg-3" *ngFor="let company of cluster;let i=index">
            <div class="d-flex">
              <div>
                <div class="company-logo">
                  <span *ngIf="company.companylogo"><img src="{{company.companylogo}}" alt=""> </span>
                  <span *ngIf="!company.companylogo"
                    class="
                      company-img
                      d-flex
                      align-items-center
                      justify-content-center
                    "
                    [ngClass]="{
                      'red-circle': i % 4 == 0,
                      'yellow-circle': i % 4 == 1,
                      'green-circle': i % 4 == 2,
                      'blue-circle': i % 4 == 3
                    }"
                    style="border: none !important"
                  >
                    {{ company.companyname.trim()[0] }}
                  </span>
                </div>
              </div>
              <div style="width: 90%;">
               <p class="font-weight-600 mb-1 text-truncate">
                  <a data-testid="auto-app-companylist-a-2" routerLinkActive="active"
                    class="text-black"
                    [title]="company.companyname"
                    [routerLink]="['/company-directory', company?.companyname, company?.companyid]"
                    [queryParams] = "{industry:industry.industryname}">
                    {{company.companyname}}
                  </a>
                </p>
               <p class="gray-text mb-0 f-12">{{company.city ? company.city : 'Not available'}}</p>
              </div>
            </div>
          </div>
          </div>
        </div>
        <hr/>
        <ngb-pagination class="d-flex justify-content-center"
         [collectionSize]="totalCompanies"
         [(page)]="activePage"
         [maxSize] = "5"
         [pageSize]="100"
         [boundaryLinks]="true"
         (pageChange)="pagination('page', $event)"></ngb-pagination>
      </div>
    </div>
  </div>

<div *ngIf="companyList.length==0" class="companypages-emptystate">
  <img src="https://previewresume.s3.ap-south-1.amazonaws.com/pq16brgnh" alt="Empty-state" /> <br/>
  <p>No company list was found here</p>
</div>
